import {
  CalculatorIcon,
  ChartBarSquareIcon,
  ChatBubbleBottomCenterTextIcon,
  ClipboardIcon,
  Cog6ToothIcon,
  CreditCardIcon,
  DocumentTextIcon,
  IdentificationIcon,
  InformationCircleIcon,
  ListBulletIcon,
  PrinterIcon,
  Squares2X2Icon,
  StarIcon,
  UsersIcon,
  CalendarIcon,
  DeviceTabletIcon,
} from "@heroicons/react/24/outline";

export const SIDEBAR_MENU = [
  {
    name: "dashboard",
    icon: Squares2X2Icon,
    title: "back.management.sidebar.dashboard",
    children: [],
  },
  {
    name: "menu",
    icon: ListBulletIcon,
    title: "back.management.sidebar.menu.title",
    children: [
      {
        name: "categories",
        title: "back.management.sidebar.menu.category",
      },
      {
        name: "products",
        title: "back.management.sidebar.menu.product",
      },
      {
        name: "option-lists",
        title: "back.management.sidebar.menu.optionList",
      },
      {
        name: "options",
        title: "back.management.sidebar.menu.option",
      },
      {
        name: "upsell",
        title: "back.management.sidebar.menu.upsell",
      },
    ],
  },
  {
    name: "orders",
    icon: DocumentTextIcon,
    title: "back.management.sidebar.orderToday",
    children: [],
  },
  {
    name: "appointments",
    icon: CalendarIcon,
    title: "back.management.sidebar.appointments",
    children: [],
  },
  {
    name: "transactions",
    icon: CreditCardIcon,
    title: "back.management.sidebar.transaction",
    children: [],
  },
  {
    name: "reports",
    icon: CalculatorIcon,
    title: "back.management.sidebar.report",
    children: [],
  },
  {
    name: "device",
    icon: DeviceTabletIcon,
    title: "back.management.sidebar.device.title",
    children: [
      {
        name: "printers",
        title: "back.management.sidebar.printer.title",
      },
      {
        name: "pos",
        title: "back.management.sidebar.device.pos",
      },
    ],
  },
  {
    name: "loyalty",
    icon: StarIcon,
    title: "back.management.sidebar.customers.loyalty",
    children: [],
  },
  {
    name: "employee",
    icon: UsersIcon,
    title: "back.management.sidebar.employee",
    children: [],
  },
  {
    name: "information",
    icon: InformationCircleIcon,
    title: "back.management.sidebar.business.information",
    children: [],
  },
  {
    name: "promotions",
    icon: IdentificationIcon,
    title: "back.management.sidebar.menu.promotion",
    children: [],
  },
  {
    name: "analytics",
    icon: ChartBarSquareIcon,
    title: "back.management.sidebar.analytics",
    children: [],
  },
  {
    name: "support",
    icon: ChatBubbleBottomCenterTextIcon,
    title: "back.management.sidebar.support",
    children: [],
  },
  {
    name: "settings",
    icon: Cog6ToothIcon,
    title: "back.management.sidebar.settings",
    children: [],
  },
];
